/* eslint-disable consistent-return */
import { I18n } from 'react-redux-i18n';
import { message } from 'antd';
// import history from './history';
import { exit } from '../actions';

export default function processError(error, dispatch) {
  if (error.status == '401') {
    if (dispatch) {
      dispatch(exit());
    } else {
      document.location.reload();
    }
    // history.push('/');
    return;
  }

  if (error.status == '404' || error.status == '400' || error.status == '401') {
    message.error(error.message || error.error);
    return;
  }

  return {
    status: false,
    message: 'Error',
  };
}
